import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import appConfig from '../../../app-config';
import { cognitoForgotPassword } from '../../../authentication/cognito';
import { ButtonVariant, FeedbackType, FormControlType, Variant } from '../..';
import * as formik from 'formik';
import * as yup from 'yup';

import '../login.scss';

export default function FormForgotPassword({ onNotifyEvent, onSwitchToLogin, onSwitchToResetPassword }) {

    const [submitButtonEnabled, setSubmitButtonEnabled] = useState(true);

    const handleSwitchToLogin = () => {
        onSwitchToLogin();
    }

    const handleForgotPassword = (e) => {
        setSubmitButtonEnabled(false);

        cognitoForgotPassword(e.email).then((result) => {
            onSwitchToResetPassword(e);

            onNotifyEvent({
                email: e.email,
                notificationTitle: 'Success',
                notificationMessage: result,
                notificationType: Variant.SUCCESS,
            });
        }).catch((error) => {
            setSubmitButtonEnabled(true);

            onNotifyEvent({
                notificationTitle: 'Error',
                notificationMessage: error,
                notificationType: Variant.DANGER,
            });
        });
    }

    const { Formik } = formik;

    const schema = yup.object().shape({
        email: yup.string().matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,}$/i, 'Invalid email format').required('Email address is required'),
    });

    const initialValues = {
        email: '',
    }

    return (
        <div>
            <div className={'app-login-header'}>
                <div className={'app-title'}>{appConfig.app.title}</div>
                <div>{'Enter your email address'}</div>
            </div>

            <Formik
                validationSchema={schema}
                initialValues={initialValues}
                onSubmit={handleForgotPassword}
            >
                {({ handleSubmit, handleChange, values, touched, errors }) => (
                    <Form noValidate onSubmit={handleSubmit}>

                        <Row>
                            <Form.Group as={Col} size='sm'>
                                <FloatingLabel
                                    label='Email address'
                                    className='mb-3'
                                >
                                    <Form.Control
                                        type={FormControlType.EMAIL}
                                        name='email'
                                        placeholder='name@example.com'
                                        value={values.email}
                                        onChange={handleChange}
                                        isValid={touched.email && !errors.email}
                                        isInvalid={touched.email && !!errors.email}
                                    />
                                    <Form.Control.Feedback></Form.Control.Feedback>
                                    <Form.Control.Feedback type={FeedbackType.INVALID}>{errors.email}</Form.Control.Feedback>
                                </FloatingLabel>
                            </Form.Group>
                        </Row>

                        <Row className='app-form-button-row'>
                            <Button
                                variant={ButtonVariant.SUCCESS}
                                type={FormControlType.SUBMIT}
                                disabled={!submitButtonEnabled}
                            >
                                Send Code
                            </Button>
                        </Row>

                        <Row className='app-form-button-link-row'>
                            <span>Return to
                                <Button
                                    className='app-button-link app-button-link-margin-top'
                                    variant={ButtonVariant.LINK}
                                    onClick={handleSwitchToLogin}>
                                    Login
                                </Button>
                            </span>
                        </Row>
                    </Form>
                )}
            </Formik>
        </div>
    );
}